<template>
  <div class="admin_misc" data-testid="admin_misc">
    <v-toolbar grey>
      <v-toolbar-title>Misc</v-toolbar-title>
    </v-toolbar>
    <v-container>
      <v-btn color="error" @click="crash_modal = true">
        Crash test
      </v-btn>

      <v-dialog v-model="crash_modal" max-width="500" persistent>
        <v-card>
          <v-card-title>Crash test</v-card-title>
          <v-card-text>
            This will call the server crash_test route; the server will panic and the request will fail.
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn text @click="crash_modal = false">Cancel</v-btn>
            <v-btn color="error" :loading="loading" @click="crash_test">
              Trigger crash
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      crash_modal: false,
      loading: false,
    };
  },
  methods: {
    crash_test() {
      this.loading = true;
      axios
        .get("/api/util/crash_test")
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>
